import IndividualBusiness from "./IndividualBusiness";

export default IndividualBusiness;
